// extracted by mini-css-extract-plugin
export default {"login-with-password-page":"styles_login-with-password-page__Axril","login-with-password-page-form":"styles_login-with-password-page-form__lqMi7"};